import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AwardAgentComponent,
  AwardAgentDetailComponent,
  AwardAgentDetailsComponent,
  AwardAgentLetterComponent,
  AwardAgentCertificateComponent,
  AwardAgentContactComponent,
  AwardAgentListComponent,
  AwardAgentRowComponent,
  //Dashboard
  DashboardComponent,
  DashboardInner,
  DashboardContainerComponent,
  DashboardInvoiceComponent,
  DashboardAppComponent,
  DashboardRecordComponent,
  DashboardCompanyComponent,
  DashboardInvoiceListComponent,
  LotAgentComponent,
  LotAgentDetailsComponent,
  LotPaymentComponent,
  LotAgentListComponent,
  LotAgentRowComponent,
  //Profile
  ProfileAgentDetailsComponent,
  ProfileComponent,
  ProfileDocumentComponent,
  //Invoci
  InvoiceComponent,
  InvoiceListComponent,
  InvoicePaymentListComponent,
  InvoiceRowComponent,
  InvoiceUnitComponent,
  RegisteredCompanyComponent,
  //Register-Company
  CompanyDetailComponent,
  CompanyDocumentComponent,
  CompanyDirectorComponent,
  CompanyEquipmentComponent,
  OfficialEquipmentComponent,
  OfficialListComponent,
  ArchivedEquipmentComponent,
  CompanyUserComponent,
  CompanyRecordComponent,
  CompanyProfileComponent,
  RecordComponent,
  RowComponent,

  //Setting
  SettingAgentDetailsComponent,
  SettingComponent,
  SettingDocumentComponent,
  //Chat
  ChatComponent,
  MessageComponent,
  CommentNestedComponent,
  AccountSecurityComponent,
  //Role
  RoleDetailComponent,
  RoleNewComponent,
  RoleListComponent,
  RoleRowComponent,
  RoleEditComponent,
  ApplicationComponent,
  NotificationComponent,
  ConfigurationComponent,
  VerificationStep1Component,
  VerificationStep2Component,
  VerificationComponent,
  AolRowComponent,
  AolListComponent,
  ManageAolListComponent,
  NetworkOperatorRowComponent,
  NonNetworkOperatorRowComponent,
  DocumentUploadRowComponent,
  OfficialEquipmentRowComponent,
  //EWallet
  EWalletComponent,
  ActivateEWalletComponent,
  AccountsComponent,
  AccountsRowComponent,
  WalletTransactionsComponent,
  TransactionsRowComponent,
  WithdrawalRequestComponent,
  WithdrawalRequestRowComponent,
  AccountSidebarComponent,
  BankChangeRequestComponent,
  BankChangeRequestRowComponent,
  CompanyOwnershipStructureComponent,
  DirectorsUpdateModeComponent,
  HistoryRowComponent,
  HistoryRecordComponent,
  VerifiedRowComponent,
  VerifiedRecordComponent,
} from './components';
import { ContractorComponent } from './contractor.component';
import { AuthenticationGuard } from 'src/modules/core/guards/authentication';

import { AdminAuthGuard } from 'src/modules/core/guards/admin';
import { ContractorAuthGuard } from 'src/modules/core/guards/contractor';
import { EntitiesAuthGuard } from 'src/modules/core/guards/entities';
import * as path from 'path';
import { OfficialDocumentComponent } from './components/registered-company/company-document/official-document/official-document.component';
import { ArchivedDocumentComponent } from './components/registered-company/company-document/archived-document/archived-document.component';
import { CompanyShareholderComponent } from './components/registered-company/company-shareholder/company-shareholder.component';
import { CompanyPersonnelComponent } from './components/registered-company/company-personnel/company-personnel.component';
import { ConfirmGuard } from './components/registered-company/company-personnel/confirm.guard';
import { ActivatingEWalletComponent } from './components/e-wallet/activating-e-wallet/activating-e-wallet.component';
import { FundWalletComponent } from './components/e-wallet/fund-wallet/fund-wallet.component';
import { AllConversationsComponent } from './components/chat-window/all-conversations/all-conversations.component';
import { ConversationViewComponent } from './components/chat-window/conversation-view/conversation-view.component';
import {
  PaymentInstructionComponent,
  UploadProofOfPaymentComponent,
} from '../public/components';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { ConversationScreenComponent } from './components/chat-window/conversation-screen/conversation-screen.component';
import { VerifiedStructureComponent } from './components/registered-company/ownership-structures/verified-structure/verified-structurecomponent';
import { HistoryStructureComponent } from './components/registered-company/ownership-structures/history/history-structure.component';
import { PendingStructureComponent } from './components/registered-company/ownership-structures/pending-structure/pending-structure.component';
import { ConfirmStructureGuard } from './components/registered-company/ownership-structures/confirm.guard';
import { SupportingDocumentsComponent } from './components/registered-company/supporting-documents/supporting-documents.component';
import { OfficalSupportingDocumentsComponent } from './components/registered-company/supporting-documents/offical-supporting-documents/offical-supporting-documents.component';
import { WalletAuthGuard } from 'src/modules/core/guards/wallet';
import { OwnershipContractorAuthGuard } from 'src/modules/core/guards/ownershipGuard';
import { PermissionGuard } from './guard/permission.guard';
import { AIChatComponent } from '../contractor/components/ai-chat/ai-chat.component';
import { AIChatScreenComponent } from '../contractor/components/ai-chat/chat-screen/ai-chat-screen.component';
import { AIUserChatComponent } from '../contractor/components/ai-chat/chat-screen/ai-user-chat/ai-user-chat.component';
import { AIConversationComponent } from '../contractor/components/ai-chat/ai-conversation/ai-conversation.component';
import { AIConversationScreenComponent } from '../contractor/components/ai-chat/chat-view/conversation-screen/ai-conversation-screen.component';
import { AIChatMessagesComponent } from '../contractor/components/ai-chat/chat-view/chat-messages/ai-chat-messages.component';

export const COMPONENTS: Array<any> = [
  //Award
  AwardAgentComponent,
  AwardAgentDetailComponent,
  AwardAgentDetailsComponent,
  AwardAgentLetterComponent,
  AwardAgentListComponent,
  AwardAgentRowComponent,
  //Dashboard
  DashboardComponent,
  DashboardInner,
  DashboardContainerComponent,
  DashboardInvoiceComponent,
  DashboardAppComponent,
  DashboardRecordComponent,
  DashboardCompanyComponent,
  DashboardInvoiceListComponent,
  AwardAgentCertificateComponent,
  AwardAgentContactComponent,
  //Lot
  LotAgentComponent,
  LotAgentDetailsComponent,
  LotPaymentComponent,
  LotAgentListComponent,
  LotAgentRowComponent,
  //Profile
  ProfileAgentDetailsComponent,
  ProfileComponent,
  ProfileDocumentComponent,
  //Invoci
  InvoiceComponent,
  InvoiceListComponent,
  InvoicePaymentListComponent,
  InvoiceRowComponent,
  InvoiceUnitComponent,
  NotificationComponent,

  RegisteredCompanyComponent,
  //Register-Company
  CompanyDetailComponent,
  CompanyDocumentComponent,
  CompanyDirectorComponent,
  CompanyEquipmentComponent,
  CompanyUserComponent,
  CompanyRecordComponent,
  CompanyProfileComponent,
  RecordComponent,
  RowComponent,
  HistoryRowComponent,
  HistoryRecordComponent,
  VerifiedRowComponent,
  VerifiedRecordComponent,
  SettingAgentDetailsComponent,
  SettingComponent,
  SettingDocumentComponent,
  //Chat
  ChatComponent,
  MessageComponent,
  CommentNestedComponent,

  // AI Chat
  // AI CHAT
  AIChatComponent,
  AIChatScreenComponent,
  AIConversationComponent,
  AIUserChatComponent,
  AIConversationScreenComponent,
  AIChatMessagesComponent,

  AccountSecurityComponent,
  //Role
  RoleDetailComponent,
  RoleNewComponent,
  RoleListComponent,
  RoleRowComponent,
  RoleEditComponent,
  ApplicationComponent,
  ConfigurationComponent,
  VerificationStep1Component,
  VerificationStep2Component,
  VerificationComponent,
  AolRowComponent,
  AolListComponent,
  ManageAolListComponent,
  NetworkOperatorRowComponent,
  NonNetworkOperatorRowComponent,
  DocumentUploadRowComponent,
  OfficialEquipmentRowComponent,
  OfficialListComponent,
  //EWallet
  EWalletComponent,
  ActivateEWalletComponent,
  AccountsComponent,
  AccountsRowComponent,
  WalletTransactionsComponent,
  TransactionsRowComponent,
  WithdrawalRequestComponent,
  WithdrawalRequestRowComponent,
  AccountSidebarComponent,
  BankChangeRequestComponent,
  BankChangeRequestRowComponent,
  FundWalletComponent,
  ActivatingEWalletComponent,
];
const routes: Routes = [
  {
    path: '',
    data: { title: '' },
    component: ContractorComponent,
    canActivate: [AuthenticationGuard, ContractorAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },

      {
        path: 'dashboard',
        data: { title: 'dashboard' },
        component: DashboardComponent,
      },
      {
        path: 'aol-manage/:id',
        data: {
          title: 'contractor aol',
          permission: { id: 'AOL', action: 'read' },
        },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard, PermissionGuard],
        component: ManageAolListComponent,
      },
      {
        path: 'aol',
        data: {
          title: '',
          permission: { id: 'AOL', action: 'read' },
        },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard, PermissionGuard],
        component: AolListComponent,
        children: [
          {
            path: 'details/:id',
            data: { title: 'contractor aol list' },
            component: ManageAolListComponent,
          },
        ],
      },
      {
        path: 'application',
        data: { title: 'contractor application' },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard],
        component: ApplicationComponent,
      },
      {
        path: 'chat',
        data: {
          title: '',
          permission: { id: 'CHAT', action: 'read' },
        },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard, PermissionGuard],
        component: ChatComponent,
        children: [
          {
            path: ':id/message',
            data: { title: 'contractor chat' },
            component: MessageComponent,
          },
        ],
        // children: [
        // { path: 'all-conversations', data: { title: "Contractor All Chat Conversations" }, component: AllConversationsComponent},
        // { path: 'conversation-view', data: { title: "Contractor Chat Conversation View " }, component: ConversationViewComponent},
        // ]
      },
      {
        path: 'chat-window',
        data: {
          title: '',
          permission: { id: 'CHAT', action: 'read' },
        },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard, PermissionGuard],
        component: ChatWindowComponent,
        children: [
          {
            path: '',
            redirectTo: 'conversation-screen/empty',
            pathMatch: 'full',
          },
          {
            path: 'conversation-screen/:id',
            data: { title: 'contractor conversation-screen' },
            component: ConversationScreenComponent,
            pathMatch: 'prefix',
          },
        ],
      },
      {
        path: 'ai-chat',
        data: { title: 'ai chat' },
        component: AIChatComponent,
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'screen' },
          // { path: ":id/message", component: MessageComponent },
          {
            path: 'screen',
            data: { title: 'ai chat screen' },
            component: AIChatScreenComponent,
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'ai-user-chat' },

              {
                path: 'ai-user-chat',
                data: { title: 'AI Chat' },
                component: AIUserChatComponent,
              },
            ],
          },
          // {
          //   path: 'watched',
          //   data: { title: 'watched chat' },
          //   component: WatchedChatComponent,
          // },
          // {
          //   path: 'customers',
          //   data: { title: 'chat customers' },
          //   component: ChatCustomersComponent,
          // },
        ],
      },
      {
        path: 'account-verification',
        data: { title: 'contractor account-verification' },
        component: VerificationComponent,
        children: [
          {
            path: 'step1',
            data: { title: 'contractor account-verification step1' },
            component: VerificationStep1Component,
          },
          {
            path: 'step2',
            data: { title: 'contractor account-verification step2' },
            component: VerificationStep2Component,
          },
        ],
      },
      {
        path: 'payment',
        data: { title: 'contractor payment' },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard],
        component: LotAgentComponent,
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            data: { title: 'contractor payment list' },
            component: LotAgentListComponent,
          },
          {
            path: 'foreign-payment/upload-proof-of-payment',
            data: { title: 'contractor payment upload-proof-of-payment' },
            component: UploadProofOfPaymentComponent,
          },

          {
            path: 'payment-instruction',
            data: { title: 'contractor payment instruction' },
            component: PaymentInstructionComponent,
          },
          {
            path: 'pay/:id',
            data: { title: 'contractor payment lot-agent-details' },
            component: LotAgentDetailsComponent,
          },
          {
            path: 'instruction',
            data: { title: 'contractor payment lot-payment' },
            component: LotPaymentComponent,
          },
        ],
      },
      {
        path: 'invoice',
        data: {
          title: '',
          permission: { id: 'INVOICES_AND_PAYMENTS', action: 'read' },
        },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard, PermissionGuard],
        component: InvoiceComponent,
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            data: { title: 'contractor invoice-list' },
            component: InvoiceListComponent,
          },
          {
            path: 'payment',
            data: { title: 'Contractor invoiced-payment-list' },
            component: InvoicePaymentListComponent,
          },
          {
            path: 'non-invoiced-payment',
            data: { title: 'contractor non-invoiced-payment-list' },
            component: InvoicePaymentListComponent,
          },
        ],
      },
      {
        path: 'setting',
        data: { title: '' },
        component: ProfileComponent,
        children: [
          {
            path: '',
            redirectTo: 'detail',
            pathMatch: 'full',
          },
          {
            path: 'detail',
            data: { title: 'contractor setting details' },
            component: ProfileAgentDetailsComponent,
          },
          {
            path: 'document',
            data: { title: 'contractor setting document' },
            component: ProfileDocumentComponent,
          },
          {
            path: 'user',
            data: { title: 'contractor setting user' },
            component: CompanyUserComponent,
          },
          {
            path: 'account-security',
            data: { title: 'contractor setting account-security' },
            component: AccountSecurityComponent,
          },
          {
            path: 'notification',
            data: {
              title: 'contractor setting notification',
            },
            component: NotificationComponent,
          },
          {
            path: 'role',
            data: {
              title: '',
            },
            children: [
              {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full',
              },
              {
                path: 'list',
                data: {
                  title: 'contractor setting role list',
                },
                component: RoleListComponent,
              },
              {
                path: 'detail/:id',
                data: {
                  title: 'contractor setting role detail',
                },
                component: RoleDetailComponent,
              },
              {
                path: 'edit/:id',
                data: {
                  title: 'contractor setting role edit',
                },
                component: RoleEditComponent,
              },
              {
                path: 'new',
                data: {
                  title: 'contractor setting role new',
                },
                component: RoleNewComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'company',
        data: {
          title: '',
          permission: { id: 'COMPANY_DETAILS', action: 'read' },
        },
        canActivate: [AuthenticationGuard, EntitiesAuthGuard, PermissionGuard],
        component: CompanyDetailComponent,
        children: [
          {
            path: '',
            redirectTo: 'profile',
            pathMatch: 'full',
          },
          {
            path: 'profile',
            data: { title: 'contractor company profile' },
            component: CompanyProfileComponent,
          },
          {
            path: 'supporting-document',
            data: { title: 'contractor company supporting document' },
            canActivate: [
              AuthenticationGuard,
              EntitiesAuthGuard,
              OwnershipContractorAuthGuard,
            ],
            component: SupportingDocumentsComponent,
            children: [
              {
                path: '',
                redirectTo: 'official-supporting',
                pathMatch: 'full',
              },
              {
                path: 'official-supporting',
                data: {
                  title: 'contractor company supporting document official',
                },
                component: OfficalSupportingDocumentsComponent,
              },
            ],
          },
          {
            path: 'document',
            data: { title: 'contractor company document' },
            canActivate: [
              AuthenticationGuard,
              EntitiesAuthGuard,
              OwnershipContractorAuthGuard,
            ],
            component: CompanyDocumentComponent,
            children: [
              {
                path: '',
                redirectTo: 'official',
                pathMatch: 'full',
              },
              {
                path: 'official',
                data: { title: 'contractor company document official' },
                component: OfficialDocumentComponent,
              },
              {
                path: 'archive',
                data: { title: 'contractor company document archive' },
                component: ArchivedDocumentComponent,
              },
            ],
          },
          {
            path: 'personnel',
            data: { title: 'contractor company personnel' },
            component: CompanyPersonnelComponent,
            canDeactivate: [ConfirmGuard],
            canActivate: [
              AuthenticationGuard,
              EntitiesAuthGuard,
              OwnershipContractorAuthGuard,
            ],
            runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
          },
          {
            path: 'ownership-structure',
            data: { title: 'contractor company personnel' },
            canDeactivate: [ConfirmStructureGuard],
            canActivate: [
              AuthenticationGuard,
              EntitiesAuthGuard,
              OwnershipContractorAuthGuard,
            ],
            component: CompanyOwnershipStructureComponent,
            runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
            children: [
              {
                path: '',
                redirectTo: 'verified',
                pathMatch: 'full',
              },
              {
                path: 'verified',
                data: { title: 'contractor company director' },
                component: VerifiedStructureComponent,
              },
              {
                path: 'pending',
                data: { title: 'contractor company director' },
                component: PendingStructureComponent,
              },
              {
                path: 'history',
                data: { title: 'contractor company director' },
                component: HistoryStructureComponent,
              },
              {
                path: 'update-mode',
                data: { title: 'contractor company director' },
                component: DirectorsUpdateModeComponent,
              },
            ],
          },
          {
            path: 'shareholder',
            data: { title: 'contractor company shareholder' },
            canActivate: [
              AuthenticationGuard,
              EntitiesAuthGuard,
              OwnershipContractorAuthGuard,
            ],

            component: CompanyShareholderComponent,
          },
          {
            path: 'record',
            data: { title: 'contractor company record' },
            canActivate: [
              AuthenticationGuard,
              EntitiesAuthGuard,
              OwnershipContractorAuthGuard,
            ],
            component: CompanyRecordComponent,
          },
          {
            path: 'equipment',
            data: { title: '' },
            canActivate: [AuthenticationGuard, EntitiesAuthGuard],
            component: CompanyEquipmentComponent,
            children: [
              {
                path: '',
                redirectTo: 'official',
                pathMatch: 'full',
              },
              {
                path: 'official',
                data: { title: 'contractor company equipment official' },
                component: OfficialEquipmentComponent,
              },
              {
                path: 'archive',
                data: { title: 'contractor company equipment official' },
                component: ArchivedEquipmentComponent,
              },
            ],
          },
          {
            path: 'user',
            data: { title: 'contractor company user' },
            canActivate: [AuthenticationGuard, EntitiesAuthGuard],
            component: CompanyUserComponent,
          },
        ],
      },
      {
        path: 'notifications',
        // canLoad: [AuthenticationGuard],
        data: { preload: true, title: 'contractot notifications' },
        // component: ApplicantLayoutComponent,
        loadChildren: () =>
          import('../notification/notification.module').then(
            (m) => m.NotificationModule
          ),
      },
      {
        path: 'wallet',
        data: {
          title: '',
          permission: { id: 'eWALLET', action: 'read' },
        },
        canActivate: [
          AuthenticationGuard,
          EntitiesAuthGuard,
          WalletAuthGuard,
          PermissionGuard,
        ],
        component: EWalletComponent,
        children: [
          {
            path: '',
            component: ActivatingEWalletComponent,
          },
          {
            path: 'activate',
            data: { title: 'contractor wallet activate' },
            component: ActivateEWalletComponent,
          },
          {
            path: 'accounts',
            data: { title: 'contractor wallet accounts' },
            component: AccountsComponent,
          },
          {
            path: 'transactions/:id',
            data: { title: 'contractor wallet transactions' },
            component: WalletTransactionsComponent,
          },
          // {
          //   path: 'withdrawal-request/:id',
          //   data: { title: 'contractor wallet withdrawal-request' },
          //   component: WithdrawalRequestComponent,
          // },
          {
            path: 'bank-change-request/:id',
            data: {
              title: 'contractor wallet bank-change-request',
            },
            component: BankChangeRequestComponent,
          },
          {
            path: 'fund-wallet',
            data: { title: 'contractor wallet fund-wallet' },
            component: FundWalletComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractorRoutingModule {}
